"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const t = require("babel-types");
/**
 * 0 -> No debugging
 * 1 -> Display labels added to applications
 * 2 -> 1 + Display state of the scope structure
 */
let debug = 0;
class Scope {
    constructor(init = []) {
        this.bindings = new Map(init);
    }
    toString() {
        let ret = "[";
        this.bindings.forEach((k, v) => ret += `${v} -> ${k}, `);
        return ret + "]";
    }
}
class Env {
    constructor() {
        this.scopes = new Array(new Scope([]));
        // TODO(rachit): Add more known globals here.
        // This is not correct in presence of renaming.
        ['WeakMap', 'Map', 'Set', 'WeakSet', 'String', 'Number', 'Function',
            'Object', 'Array', 'Date', 'RegExp', 'Error',
            'console.*', 'Object.*', 'Math.*'
        ].map(e => this.addBinding(e, 'Flat'));
    }
    toString() {
        return this.scopes.map(x => x.toString()).join("\n");
    }
    findBinding(id) {
        for (let iter in this.scopes) {
            let scope = this.scopes[iter];
            let res = scope.bindings.get(id);
            // This is member expression of the form a.b
            if (id.split(".").length === 2) {
                res = scope.bindings.get(id.split(".")[0] + "." + "*");
            }
            if (res) {
                return res;
            }
        }
        // NOTE(rachit): If can't find the tag, be conservative and return notflat.
        return 'NotFlat';
    }
    pushScope(scope) {
        this.scopes.unshift(scope);
    }
    popScope() {
        if (this.scopes.length > 0) {
            this.scopes.shift();
        }
    }
    addBinding(id, tag) {
        if (this.scopes.length === 0) {
            throw new Error(`Tried to add ${id} with tag ${tag} in empty Env`);
        }
        else {
            this.scopes[0].bindings.set(id, tag);
            this.scopes[0].bindings.set(id + '.call', tag);
            this.scopes[0].bindings.set(id + '.apply', tag);
        }
    }
}
let globalEnv = new Env();
function nodeToString(node) {
    switch (node.type) {
        case 'Identifier': return node.name;
        case 'MemberExpression': {
            const oname = nodeToString(node.object);
            const pname = nodeToString(node.property);
            return oname && pname ? oname + "." + pname : null;
        }
        default: {
            return null;
        }
    }
}
/**
 * Visitors that run mark call expressions as 'flat'
 */
const markCallExpression = function (path) {
    if (path.node.mark === 'Flat') {
        return;
    }
    const node = path.node;
    const name = nodeToString(node.callee);
    if (name) {
        const tag = globalEnv.findBinding(name);
        if (debug > 0) {
            console.error(`${name} -> ${tag} on line ${path.node.loc ?
                path.node.loc.start.line : ""}`);
        }
        node.mark = tag;
        node.callee.mark = tag;
    }
};
const programMarkCallExpression = function (path) {
    if (path.node.mark === 'Flat') {
        return;
    }
    const fParent = path.findParent(p => t.isFunctionDeclaration(p) ||
        t.isFunctionExpression(p));
    if (fParent === null || fParent === undefined) {
        const node = path.node;
        if (t.isFunctionExpression(node.callee)) {
            node.mark = node.callee.mark;
            return;
        }
        const name = nodeToString(node.callee);
        if (name) {
            const tag = globalEnv.findBinding(name);
            if (debug > 0) {
                console.error(`${name} -> ${tag} on line ${path.node.loc ?
                    path.node.loc.start.line : ""}`);
            }
            node.mark = tag;
            node.callee.mark = tag;
        }
    }
};
const func = {
    enter(path) {
        let paramsBind = path.node.params.map(p => [p.name, 'NotFlat']);
        if (path.node.id) {
            globalEnv.addBinding(path.node.id.name, path.node.mark);
            // The function name is bound to its own mark and all the params are
            // marked as not flat.
            let binds = [[path.node.id.name, path.node.mark], ...paramsBind];
            globalEnv.pushScope(new Scope(binds));
        }
        else {
            globalEnv.pushScope(new Scope(paramsBind));
        }
    },
    exit(path) {
        if (debug > 1) {
            console.error(`\n-------${path.node.id.name}----------`);
            console.error(globalEnv.toString());
            console.error(`\n-------------------------`);
        }
        path.traverse(markingVisitor);
        globalEnv.popScope();
    }
};
const assign = {
    // NOTE(rachit): This naively assumes that all IDs that are assigned to
    // are not flat. A better alternative to this is to check if the assignment
    // is itself a flat function and give a tag accordingly.
    enter(path) {
        const name = nodeToString(path.node.left);
        if (name) {
            globalEnv.addBinding(name, 'NotFlat');
            if (debug > 0) {
                console.error(`${name} -> NotFlat on line ${path.node.loc ?
                    path.node.loc.start.line : ""} because of assignment`);
            }
        }
    }
};
const program = {
    enter(path) {
        globalEnv = new Env();
    },
    exit(path) {
        if (debug > 1) {
            console.error(`\n-------program----------`);
            console.error(globalEnv.toString());
            console.error(`\n-------------------------`);
        }
        path.traverse(programMarkingVisitor);
    }
};
// The Program visitor needs to ignore all function bodies
const programMarkingVisitor = {
    CallExpression: programMarkCallExpression,
    NewExpression: programMarkCallExpression
};
const markingVisitor = {
    CallExpression: markCallExpression,
    NewExpression: markCallExpression
};
const visitor = {
    Program: program,
    FunctionDeclaration: func,
    FunctionExpression: func,
    AssignmentExpression: assign,
};
function markFlatApplications() {
    return { visitor };
}
exports.markFlatApplications = markFlatApplications;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// .-continuations-compiler/dist/src/compiler/markFlatApplications.js
// module id = 810
// module chunks = 0